import { executionLogStateSelector } from "./executionLogStateSelector";
import { RootState } from "../../store";

export const executionLogDatesSelector = (state: RootState) => {
  const data = executionLogStateSelector(state);

  return data.dates;
};
